"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeCodePromotions = computeCodePromotions;
const cents_1 = require("../money/cents");
const validate_1 = require("./validate");
// Famille « code promo » (v1 : __getCodesPromotionsComputed,
// apps/os/src/v1/lib/promotion.ts:108-141).
//
// R5 : la v1 calculait le pourcentage sur une variable `totalPrice` restée à 0
// — un code en pourcentage rendait donc toujours une remise nulle. Ici le
// pourcentage porte sur le sous-total de la commande, arrondi demi-haut (R3).
// Plusieurs codes se calculent chacun sur le sous-total d'origine (v1) ; le
// plafonnement au reste à payer est fait par applyPromotions.
function computeCodePromotions(subtotal, promotions) {
    return promotions.map((promotion) => {
        let discount;
        if (promotion.discountMode === 'PERCENTAGE') {
            (0, validate_1.assertPromotionPercent)(promotion.discountValue, 'code.discountValue');
            discount = (0, cents_1.applyPercent)(subtotal, promotion.discountValue);
        }
        else {
            (0, validate_1.assertPromotionAmount)(promotion.discountValue, 'code.discountValue');
            discount = promotion.discountValue;
        }
        return {
            promotionId: promotion.id,
            family: 'CODE',
            orderDiscount: discount,
            itemsDiscounts: [],
            totalDiscount: discount,
        };
    });
}
